import {
  getMultimedia,
  getCategories
} from '@/calls/multimedia';

const multimedia = {
  namespaced: true,
  state: {
    limit: 5,
    page: 1,
    requests: 0,
    items: [],
    noMore: false,
    category: null,
    categories: []
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setCategories(state, categories) {
      state.categories = [...categories];
    },
    addItems(state, items) {
      // eslint-disable-next-line
      items.map(item => {
        state.items.push(item);
      });
    },
    updateCategory(state, cat) {
      state.category = cat;
    },
    updatePage(state, page) {
      state.page = page;
    },
    updateNoMore(state, flag) {
      state.noMore = flag;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    },
  },
  actions: {
    async get({ state, commit }) {
      commit('increaseRequests');

      const request = await getMultimedia(
        state.noMore ? null : {
          limit: state.limit,
          page: state.page,
          categoryid: state.category ? state.category.id : null,
        }
      );

      if (request.success) {
        commit('updateNoMore', request.data.length < state.limit);
        commit('updatePage', state.page + 1);
        commit('addItems', request.data);
      } else {
        commit('updateNoMore', true);
      }

      commit('decreaseRequests');
    },
    async categories({ commit }) {
      commit('increaseRequests');

      const request = await getCategories();

      if (request.success) {
        commit('setCategories', request.data);
      }

      commit('decreaseRequests');
    }
  }
};

export default multimedia;
